import consts from './constants';
import methods from './utils';

export default {
  data() {
    return {
      consts,
    };
  },
  methods,
};
